import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/site";

export default function Impact() {
  return (
    <section className="bg-[#FEFB0E] text-black">
      <div className="max-w-7xl mx-auto px-4 py-16 md:py-24 grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div>
          <h2 className="font-bebas text-4xl md:text-6xl leading-[0.95] uppercase tracking-tight">
            Precisou de guincho? Seu veículo parou? Nós podemos ajudar.
          </h2>
          <p className="mt-6 text-base md:text-lg font-medium leading-relaxed text-black/80">
            Conte com a Brasil Transportes para remoção e transporte de veículos leves, utilitários
            e motos. Trabalhamos com Reboque Asa Delta e Plataforma, além de serviços de apoio como
            recarga de bateria e troca de pneu.
          </p>
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="impact-whatsapp-btn"
            className="mt-8 inline-flex items-center gap-3 bg-black hover:bg-neutral-800 text-[#FEFB0E] font-extrabold uppercase text-lg md:text-xl px-8 py-4 rounded-md transition-all duration-300 hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-black"
          >
            <MessageCircle className="w-6 h-6" />
            Chamar pelo WhatsApp
          </a>
        </div>
        <div>
          <video
            src="/videos/atendimento-guincho.mp4"
            data-testid="impact-video"
            autoPlay
            muted
            loop
            playsInline
            controls
            preload="metadata"
            className="w-full rounded-md border-4 border-black shadow-2xl aspect-video object-cover bg-black"
          />
        </div>
      </div>
    </section>
  );
}
